import React from "react";
import { BrowserRouter } from "react-router-dom";
import ReservationForm from "./components/ReservationForm";
import "./App.css";

console.log("App.js が実行されています！"); // 動作確認用ログ

function App() {
  return (
    <BrowserRouter basename="/">
      <div>
        <ReservationForm />
      </div>
    </BrowserRouter>
  );
}

export default App;
